function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    )
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      )
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      )
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        )
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        parentMenuElement && parentMenuElement.classList.add('submenu-open')
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            )
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open')
      })
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer()
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus(detailsElement.querySelector('summary'))
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header')
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    )
    this.header.classList.add('menu-open')

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus)
    this.header.classList.remove('menu-open')
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    )
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide()
      })
    }
  }

  connectedCallback() {
    if (this.moved) return
    this.moved = true
    document.body.appendChild(this)
  }

  show(opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    document.body.dispatchEvent(new CustomEvent('modalClosed'))
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')

    if (!button) return
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'))
      if (modal) modal.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      )
      if (focus) deferredElement.focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor() {
    super()
    this.slider = this.querySelector('[id^="Slider-"]')
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.enableSliderLooping = false
    this.currentPageElement = this.querySelector('.slider-counter--current')
    this.pageTotalElement = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')

    if (!this.slider || !this.nextButton) return

    this.initPages()
    const resizeObserver = new ResizeObserver((entries) => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    )
    if (this.sliderItemsToShow.length < 2) return
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    )
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
    this.update()
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
    this.initPages()
  }

  update() {
    const previousPage = this.currentPage
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage
      this.pageTotalElement.textContent = this.totalPages
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      )
    }

    if (this.enableSliderLooping) return

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled')
    } else {
      this.prevButton.removeAttribute('disabled')
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled')
    } else {
      this.nextButton.removeAttribute('disabled')
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const step = event.currentTarget.dataset.step || 1
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }
}

customElements.define('slider-component', SliderComponent)

class SlideshowComponent extends SliderComponent {
  constructor() {
    super()
    this.sliderControlWrapper = this.querySelector('.slider-buttons')
    this.enableSliderLooping = true

    if (!this.sliderControlWrapper) return

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    )
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    )
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this))
    this.setSlideVisibility()

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay()
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')
    this.autoplaySpeed = this.slider.dataset.speed * 1000

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    )
    this.addEventListener('mouseover', this.focusInHandling.bind(this))
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this))
    this.addEventListener('focusin', this.focusInHandling.bind(this))
    this.addEventListener('focusout', this.focusOutHandling.bind(this))

    this.play()
    this.autoplayButtonIsSetToPlay = true
  }

  onButtonClick(event) {
    super.onButtonClick(event)
    const isFirstSlide = this.currentPage === 1
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length

    if (!isFirstSlide && !isLastSlide) return

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    })
  }

  update() {
    super.update()
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')
    this.prevButton.removeAttribute('disabled')

    if (!this.sliderControlButtons.length) return

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active')
      link.removeAttribute('aria-current')
    })
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    )
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    )
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target)
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
    this.play()
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target)
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play()
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause()
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off')
    clearInterval(this.autoplay)
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    )
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite')
    clearInterval(this.autoplay)
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      )
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused')
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      )
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a')
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex')
          })
        item.setAttribute('aria-hidden', 'false')
        item.removeAttribute('tabindex')
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1')
          })
        item.setAttribute('aria-hidden', 'true')
        item.setAttribute('tabindex', '-1')
      }
    })
  }

  linkToSlide(event) {
    event.preventDefault()
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage)
    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }
}

customElements.define('slideshow-component', SlideshowComponent)

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.labelchange()
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      //this.updateURL();
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  labelchange() {
    // if($('.image_gallary_wrapper').attr('data-logic') == 'true'){}
    var curr_id = this.currentVariant.id
    $('.product_labelInstock').addClass('hidden')
    $('.product_labelInstock[data-id="' + curr_id + '"]').removeClass('hidden')
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    )
    if (
      $(mediaGalleries)
        .closest('.product_gallery_left')
        .find('.product__mainImage.slick-initialized').length > 0
    ) {
      const mainSliderDektop = $(
        $(mediaGalleries)
          .closest('.product_gallery_left')
          .find('.product__mainImage.slick-initialized')
      )
      let currMedia = this.currentVariant.featured_media.id
      let sliderI = document
        .querySelector(".product_mainImageList[data-id='" + currMedia + "']")
        .getAttribute('data-slick-index')
      mainSliderDektop.slick('slickGoTo', sliderI)
    }
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    )

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    )
    if (!modalContent) return
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    )
    modalContent.prepend(newMediaModal)
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState(
      {},
      '',
      `${window.Shopify.locale == 'fr' ? '/fr' : ''}${
        this.dataset.url
      }?variant=${this.currentVariant.id}`
    )
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
      if (this.currentVariant.compare_at_price) {
        this.setmoneyformat(this.currentVariant.compare_at_price)
      } else {
        document.querySelector('[name="properties[Cmp_price]"]').value = ''
      }
    })
  }

  setmoneyformat(price) {
    var set_price_format = Shopify.formatMoney(price)
    document.querySelector('[name="properties[Cmp_price]"]').value =
      set_price_format
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // jQuery(".price_one_line").css("opacity","0");
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        )
        const destination1 = document.getElementById(
          `price1-${this.dataset.section}`
        )
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        const source1 = html.getElementById(
          `price1-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        )
        if (source && destination) {
          destination.innerHTML = source.innerHTML
          if (destination1 != null) {
            destination1.innerHTML = source1.innerHTML
          }
          if (destination.querySelector('.price.price--on-sale') != null) {
            var _price = source.querySelector(
              '.price.price--on-sale .price__sale .price-item--last'
            ).innerHTML
          } else {
            var _price = source.querySelector(
              '.price .price__regular .price-item--regular'
            ).innerHTML
          }
          if (_price != null) {
            var _priceDivFound = destination
              .closest('.product__info-container')
              .querySelector('.showAddtoCart-price')
            if (_priceDivFound != null) {
              _priceDivFound.innerHTML = _price.trim()
            }
          }

          if (
            document.querySelector(
              '.atc-btn-wrapper .price-block .price_one_line'
            ) != null
          ) {
            document.querySelector(
              '.atc-btn-wrapper .price-block .price_one_line'
            ).innerHTML = source.innerHTML
            document
              .querySelector(
                '.atc-btn-wrapper .price-block .price_one_line .custom_pay-bright-head'
              )
              .remove()
          }
          if (source.querySelector('.custom_paybright .buynow_text') != null) {
            document.querySelector(
              '.atc-btn-wrapper .monthy-price label'
            ).innerHTML = source.querySelector(
              '.custom_paybright .buynow_text'
            ).innerHTML
            document.querySelector(
              '.atc-btn-wrapper .price-wrapper .monthly-price'
            ).innerHTML =
              source.querySelector('.custom_paybright .price').innerHTML + '/mo'
          }
          console.log(typeof pb_prequalify_init == 'function')
          if (typeof pb_prequalify_init == 'function') {
            pb_prequalify_init()
          }
          function fun_for_affirm() {
            let temp = 0
            let affirmPrice_text = $(
              '.product-v2 .paybright-widget-container'
            ).text()
            let textArray = affirmPrice_text.split(' ')
            // console.log(textArray);
            var arrayText = []
            $.each(textArray, function (key, value) {
              if (value.includes('$')) {
                var price = value
                arrayText.push(price)
              }
              if (value.includes('bi-weekly')) {
                var time = 'Weekly:'
                arrayText.push(time)
              } else if (value.includes('bi-monthly')) {
                var time = 'Monthly:'
                arrayText.push(time)
              } else {
                temp++
              }
            })
            if (textArray.length == temp) arrayText[1] = ''

            /*var svg_logo= '<svg width="40" height="14" viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_19_1699)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.685 7.88862C2.63571 7.88862 1.41929 8.34131 0.76 8.81077L1.36357 9.95089C1.89286 9.51497 2.74714 9.1461 3.51786 9.1461C4.25143 9.1461 4.65071 9.36407 4.65071 9.80838C4.65071 10.1102 4.38143 10.2611 3.88 10.3198C1.98571 10.5377 0.5 11.0072 0.5 12.3233C0.5 13.3629 1.32643 14 2.60786 14C3.52714 14 4.34429 13.5389 4.73429 12.9353V13.8323H6.44286V10.0683C6.44286 8.51736 5.245 7.88862 3.685 7.88862ZM3.04429 12.7928C2.56143 12.7928 2.32 12.5832 2.32 12.2311C2.32 11.5772 3.12786 11.3593 4.60429 11.2168C4.61357 12.0886 3.95429 12.7928 3.04429 12.7928Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5536 9.02874V8.05628H20.845V13.8323H22.6743V11.0491C22.6743 9.72455 23.5564 9.33892 24.1786 9.33892C24.42 9.33892 24.745 9.40598 24.9586 9.5485L25.2929 8.02275C25.0143 7.91377 24.7171 7.88862 24.4757 7.88862C23.5379 7.88862 22.9436 8.26586 22.5536 9.02874Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.78 7.88862C32.8143 7.88862 32.09 8.40838 31.7093 8.90299C31.3564 8.25748 30.6229 7.88862 29.7314 7.88862C28.7657 7.88862 28.0971 8.37485 27.7814 8.92814V8.05628H26.0171V13.8323H27.8464V10.8563C27.8464 9.79161 28.4686 9.28023 29.0443 9.28023C29.5643 9.28023 30.0471 9.58203 30.0471 10.3701V13.8323H31.8857V10.8563C31.8857 9.77485 32.4893 9.28023 33.0929 9.28023C33.5757 9.28023 34.0864 9.5988 34.0864 10.3617V13.8323H35.9157V9.84191C35.9157 8.54251 34.95 7.88862 33.78 7.88862Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9057 7.62874V8.05628H10.1293V7.46946C10.1293 6.70658 10.6121 6.48862 11.03 6.48862C11.2714 6.48862 11.5871 6.53892 11.8471 6.67305L12.4136 5.50778C12.0793 5.33173 11.5314 5.17245 10.7979 5.17245C9.62786 5.17245 8.3 5.76766 8.3 7.63712V8.06467H7.24143V9.33892H8.3V13.8323H10.1293V9.33053H12.9057V13.8323H14.735V9.33053H16.3971V8.05628H14.735V7.46946C14.735 6.70658 15.2179 6.48862 15.6357 6.48862C16.1 6.48862 16.4529 6.67305 16.4529 6.67305L17.0193 5.50778C17.0193 5.50778 16.4436 5.17245 15.4036 5.17245C14.2429 5.16407 12.9057 5.75928 12.9057 7.62874Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4836 8.05628H19.3129V13.8323H17.4836V8.05628Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.1443 0C23.2043 0 18.8029 3.09341 17.5586 7.07545H19.3507C20.3907 4.10778 23.9286 1.50898 28.1443 1.50898C33.27 1.50898 37.69 5.02994 37.69 10.5126C37.69 11.7449 37.5136 12.8515 37.1793 13.8323H38.9157L38.9343 13.782C39.2222 12.7677 39.3615 11.6695 39.3615 10.5126C39.3615 4.4012 34.4307 0 28.1443 0Z" fill="#4A4AF4"/></g><defs><clipPath id="clip0_19_1699"><rect width="39" height="14" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>';
              var svg_learnMore = '<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 0C3.1838 0 0.5 2.6835 0.5 6C0.5 9.31615 3.1835 12 6.5 12C9.8162 12 12.5 9.3165 12.5 6C12.5 2.6838 9.8165 0 6.5 0ZM6.32246 8.80826C5.98285 8.80826 5.72223 8.52394 5.72223 8.2001C5.72223 7.86839 5.99075 7.59199 6.32246 7.59199C6.6542 7.59199 6.93057 7.86841 6.93057 8.20013C6.93057 8.52391 6.66205 8.80826 6.32246 8.80826ZM7.22279 5.736C6.78842 6.07561 6.7805 6.31254 6.7805 6.72321C6.7805 6.8733 6.70152 7.04705 6.31454 7.04705C5.9907 7.04705 5.88017 6.92857 5.88017 6.5179C5.88017 5.83868 6.18029 5.51487 6.40932 5.31743C6.66995 5.09627 7.11223 4.85147 7.11223 4.425C7.11223 4.06167 6.79632 3.88793 6.40142 3.88793C5.59585 3.88793 5.76962 4.49609 5.3431 4.49609C5.12987 4.49609 4.86924 4.35389 4.86924 4.0459C4.86924 3.61943 5.3589 2.98758 6.42512 2.98758C7.43602 2.98758 8.10734 3.54834 8.10734 4.29073C8.10734 5.03311 7.43602 5.57016 7.22279 5.736Z" fill="#676870"/></svg>';
              $('.product-v2 .paybright-widget-container').after('<div class="custom_paybright"><div class="buynow_text">Pay '+ arrayText[1] +'</div><span class="price">'+arrayText[0]+'</span> <div class="icon-inline">with'+svg_logo +'<span class="learn_more">'+svg_learnMore+'</span></div></div>');*/
            $(
              '.product-v2 .paybright-widget-container+.custom_paybright.hidden'
            ).removeClass('hidden')

            $('.product-v2 .learn_more').click(function () {
              $('.product-v2 .paybright-widget-container a')[0].click()
            })
            // jQuery(".price_one_line").css("opacity","1");
          }
          let for_affirm = setTimeout(fun_for_affirm, 2000)
        }

        const price = document.getElementById(`price-${this.dataset.section}`)
        // const price1 = document.getElementById(`price1-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
        // console.log("this");
        // console.log(this.currentVariant.id);
        let curr_var_id = this.currentVariant.id
        // console.log(jQuery("span[data-id="+curr_var_id+"]").attr("data-msg"));
        let data_msg = jQuery(
          'span.instock_msg[data-id=' + curr_var_id + ']'
        ).attr('data-msg')
        if (data_msg != '') {
          jQuery('.product-v2 .instock-text').css('opacity', '1')
          jQuery('.product-v2 .instock-text label').text(data_msg)
        } else {
          jQuery('.product-v2 .instock-text').css('opacity', '0')
        }
        _affirm_config = {
          public_api_key: 'YZQKN6JPZSXOP6K3',
          script: 'https://cdn1.affirm.com/js/v2/affirm.js',
          locale: 'en_CA',
          country_code: 'CAN',
        }
        ;(function (l, g, m, e, a, f, b) {
          var d,
            c = l[m] || {},
            h = document.createElement(f),
            n = document.getElementsByTagName(f)[0],
            k = function (a, b, c) {
              return function () {
                a[b]._.push([c, arguments])
              }
            }
          c[e] = k(c, e, 'set')
          d = c[e]
          c[a] = {}
          c[a]._ = []
          d._ = []
          c[a][b] = k(c, a, b)
          a = 0
          for (
            b =
              'set add save post open empty reset on off trigger ready setProduct'.split(
                ' '
              );
            a < b.length;
            a++
          )
            d[b[a]] = k(c, e, b[a])
          a = 0
          for (b = ['get', 'token', 'url', 'items']; a < b.length; a++)
            d[b[a]] = function () {}
          h.async = !0
          h.src = g[f]
          n.parentNode.insertBefore(h, n)
          delete g[f]
          d(g)
          l[m] = c
        })(
          window,
          _affirm_config,
          'affirm',
          'checkout',
          'ui',
          'script',
          'ready'
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      var _text = window.variantStrings.addToCart
      if (window.Shopify.locale == 'fr') {
        _text = window.variantStrings.fr.addToCart
      }
      addButtonText.textContent = _text
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)

class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove()
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded')
          }
        })
        .then(() => {
          this.intializeSlider()
          this.updateSliderStyle()
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this)
  }

  intializeSlider() {
    const windowWidth = document.body.getBoundingClientRect().width
    const productRecommendationsontainer = $(
      '.product-recommendations-section [data-recommendations-slider]'
    )
    if (!productRecommendationsontainer.length) return
    if (windowWidth > 749) {
      $(productRecommendationsontainer)
        .not('.slick-initialized')
        .slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              },
            },
          ],
        })
    } else {
      if ($(productRecommendationsontainer).hasClass('slick-initialized')) {
        $(productRecommendationsontainer).slick('unslick')
      }
    }
  }
  updateSliderStyle() {
    const windowWidth = document.body.getBoundingClientRect().width
    if (windowWidth < 750) return
    const productRecommendationsontainer = $(
      '.product-recommendations-section [data-recommendations-slider]'
    )
    if (!productRecommendationsontainer.length) return
    let firstContainerLeftArea = $(
      '.product-recommendations-section .page-width'
    )
      .eq(0)
      .offset().left
    $(productRecommendationsontainer)
      .closest('.product-recommendations-wrap')
      .css('padding-left', firstContainerLeftArea)
  }
}

customElements.define('product-recommendations', ProductRecommendations)

// LEVAR - Carousel JS
if ($('.product__mainImage')) {
  $('.product__mainImage').on(
    'beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      if (window.levar?.session_info.initialized) {
        var $nextSlide = $(
            '.product__mainImage .slick-slide[data-slick-index="' +
              nextSlide +
              '"]'
          )[0],
          $levarActivation = $('#levar-player')[0]
        if ($nextSlide.dataset.id == 'levar-3d-slide') {
          $levarActivation.click()
        } else {
          if ($('body').hasClass('levar_player_on')) {
            $levarActivation.click()
          }
        }
      }
    }
  )
}

window.onload = function () {
  setTimeout(() => {
    if (!window.levar?.session_info.initialized) {
      var $levarThumb = $('.product__thumbImages .levar-slide')[0],
        $levarSlide = $('.product__mainImage .levar-slide')[0]
      if ($levarThumb)
        $('.product__thumbImages').slick(
          'slickRemove',
          $levarThumb.dataset.slickIndex
        )
      if ($levarSlide)
        $('.product__mainImage').slick(
          'slickRemove',
          $levarSlide.dataset.slickIndex
        )
    }
  }, 10000)
}

// Wait for the DOM to fully load
document.addEventListener('DOMContentLoaded', function () {
  // Select all elements with the class 'accordion-box'
  const accordionBoxes = document.querySelectorAll('.accordion-box')

  // Add a click event listener to each accordion-box
  accordionBoxes.forEach(function (accordionBox) {
    accordionBox.addEventListener('click', function () {
      // Get the current page URL (referrer)
      const referrerUrl = window.location.href

      // Find all Zendesk support links for the 'en-us' version and append the referrer URL as a query parameter
      const zendeskLinksEnUs = document.querySelectorAll(
        'a[href="https://support.montrealweights.ca/hc/en-us"]'
      )
      zendeskLinksEnUs.forEach(function (zendeskLink) {
        zendeskLink.href = `https://support.montrealweights.ca/hc/en-us?referrer=${encodeURIComponent(
          referrerUrl
        )}`
      })

      // Find all Zendesk support links for the 'fr-ca' version and append the referrer URL as a query parameter
      const zendeskLinksFrCa = document.querySelectorAll(
        'a[href="https://support.montrealweights.ca/hc/fr-ca"]'
      )
      zendeskLinksFrCa.forEach(function (zendeskLink) {
        zendeskLink.href = `https://support.montrealweights.ca/hc/fr-ca?referrer=${encodeURIComponent(
          referrerUrl
        )}`
      })
    })
  })
})
